<form class="material-panel" ngNativeValidate (ngSubmit)="saveSettings()">
  <div [formGroup]="linkForm.formGroup" *ngIf="errors$ | async as errors">
    <div class="input-container name-container">
      <label for="link-group-name" trans>Name</label>
      <input type="text" id="link-group-name" formControlName="name" required minlength="3" />
      <div class="error" *ngIf="errors.name">{{ errors.name }}</div>
    </div>
    <div class="input-container slug-container">
      <slug-control [baseUri]="slugBaseUri$ | async" formControlName="hash"></slug-control>
      <div class="error" *ngIf="errors.hash">{{ errors.hash }}</div>
    </div>
    <div class="input-container">
      <label for="link-group-description" trans>Description</label>
      <textarea id="link-group-description" formControlName="description"></textarea>
    </div>
  </div>
  <link-options-form
    [featuresToHide]="hiddenFeatures"
    [linkOptions]="options$ | async"
    resourceName="biolink"
  ></link-options-form>
  <button type="submit" mat-raised-button [disabled]="editor.loading$ | async" color="accent" trans>
    Save
  </button>
</form>
